import { render } from "./CustomDashboard.vue?vue&type=template&id=5324b1d0&ts=true"
import script from "./CustomDashboard.vue?vue&type=script&lang=ts"
export * from "./CustomDashboard.vue?vue&type=script&lang=ts"

import "./CustomDashboard.vue?vue&type=style&index=0&id=5324b1d0&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__